<template>
    <div id="app">
        <counter :count="bookmarksCount"/>

        <section class="page-filter m-t-md">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="page-filter-desktop page-filter-desktop__favorites">

                            <ShareButton :text="message('share.button.text')" :enabled="buttonEnabled" />
                            <ViewModeSwitch :isList="isModeList" @mode-change="mode = $event" />

                            <a @click.stop="reset" href="#" class="page-reset-btn hidden-xs">
                                <span class="relative">
                                  <i class="fa fa-refresh" data-toggle="tooltip" data-placement="bottom" title="" :data-original-title="message('button.reset')"></i>
                                </span>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <bookmarks-container @remove-item="removeItem($event)" :bookmarks="bookmarks" :isList="isModeList">
            <share-modal :link="link" />
        </bookmarks-container>
    </div>
</template>

<script>
    import message from './i18n'
    import API from './api'
    import Counter from './components/Counter'
    import BookmarksContainer from './components/BookmarksContainer'
    import ShareButton from './components/ShareButton'
    import ShareModal from './components/ShareModal'
    import ViewModeSwitch from './components/ViewModeSwitch'

    const STORAGE_KEY = 'bookmarks';

    export default {
        name: 'app',
        components: {
            Counter,
            BookmarksContainer,
            ShareButton,
            ShareModal,
            ViewModeSwitch
        },
        data: () => ({
            bookmarks: [],
            mode: 'grid'
        }),
        computed: {
            buttonEnabled(){
                return this.bookmarks.length > 0
            },
            bookmarksCount() {
                return this.bookmarks.length || 0
            },
            isModeList() {
                return this.mode === 'list'
            },
            link() {
                return window.location.href.replace(/#.*$/, '') + '#' + API.encodeIDHash(this.bookmarks.map(e => e.identifier))
            }
        },
        methods: {
            message: message,
            removeItem(id) {
                // update localstorage
                const ids = JSON.parse(window.localStorage
                    .getItem(STORAGE_KEY))
                    .filter(e => e !== id);

                window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));

                // update cards
                this.bookmarks = this.bookmarks.filter(e => e.identifier !== id);
            },
            initBookmarksFromUrl() {
                const ids = API.decodeIDHash(window.location.hash);

                if(ids.length > 0) {
                    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
                }
            },
            reset() {
                this.bookmarks = [];
                window.localStorage.setItem(STORAGE_KEY, '[]');
            }
        },
        created() {

            this.initBookmarksFromUrl();

            const rawData = window.localStorage.getItem(STORAGE_KEY);
            if (!rawData) {
                return;
            }

            const ids = JSON.parse(rawData);

            API.retrieveList(ids).then(response => { // handle success
                this.bookmarks = response.data
            });
        }
    }
</script>

<style>

</style>
